import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./tailwind.css";
import App from "./App";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import "./fonts/CircularStd.css";
import NotificationProvider from "./components/Notifications/NotificationProvider";

ReactDOM.render(
  <Provider store={store}>
  <React.StrictMode>
    <NotificationProvider>
      <BrowserRouter>
          <App />
      </BrowserRouter>
    </NotificationProvider>
  </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
